export const QueryKeys = {
    GetAllAreas: 'get-all-areas',
}
